import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Manager, Reference, Popper } from 'react-popper';
import { SketchPicker } from 'react-color';
import useBindToContext from 'hooks/useBindToContext';
import classNames from 'lib/classNames';

const formatColor = color => {
    if (!color)
        color = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    return typeof color === 'string' ? color : `rgba(${color.r},${color.g},${color.b},${color.a})`;
};

const ColorPicker = ({
    BindToContext = null,
    value = null,
    onChange = null,
    onVisibleChange,
    text = null,
    position = 'bottom left',
    color_type = 'rgb',
    data_input,
    onFocus,
    onBlur,
    className = '',
    disableAlpha = false
}) => {
    const [BindedValue, BindedOnChange, _, onRender] = useBindToContext(
        BindToContext,
        value,
        onChange
    );
    const contentRef = useRef(null);
    const [visible, _setVisible] = useState(false);
    const setVisible = value => {
        if (onVisibleChange) onVisibleChange(value);
        _setVisible(value);
    };
    const contentStyle = {
        padding: 0,
        border: 'none',
        background: 'none',
        boxShadow: 'none',
        width: 'initial'
    };
    const arrowStyle = {
        zIndex: 1
    };

    const handleOutSideClick = event => {
        if (!contentRef.current) return;
        else if (contentRef.current.contains(event.target)) return;

        setVisible(false);
    };

    useEffect(
        () => {
            if (visible) document.addEventListener('mousedown', handleOutSideClick, false);
            else document.removeEventListener('mousedown', handleOutSideClick, false);
            return () => {
                document.removeEventListener('mousedown', handleOutSideClick, false);
            };
        },
        [visible]
    );

    //useEffect(() => {
    //if (onRender?.length) onRender.forEach(fn => fn());
    //}, [onRender]);

    return (
        <div className={classNames('flex items-center', className)}>
            <Manager>
                <Reference>
                    {({ ref }) =>
                        <button
                            type="button"
                            ref={ref}
                            className={classNames('focus:output-none', {
                                'rounded-l border-r': data_input,
                                'rounded border focus:ring': !data_input
                            })}
                            onClick={() => {
                                if (!visible) setVisible(true);
                            }}
                            data-active={visible}
                            onFocus={e => {
                                if (onFocus) onFocus(e);
                            }}
                            onBlur={e => {
                                if (onBlur) onBlur(e);
                            }}
                            style={{
                                width: 37,
                                height: 37,
                                backgroundColor: formatColor(BindedValue)
                            }}
                            tabIndex="0"
                        />}
                </Reference>
                <Popper
                    placement="right-start"
                    positionFixed={false}
                    modifiers={{
                        preventOverflow: { enabled: true },
                        offset: { offset: '100%r,0px', enabled: true }
                    }}
                >
                    {({ ref, style, placement, arrowProps }) => {
                        return visible
                            ? <div ref={contentRef}>
                                  <div
                                      ref={ref}
                                      style={{ ...style, zIndex: 100 }}
                                      data-placement={placement}
                                  >
                                      <SketchPicker
                                          disableAlpha={disableAlpha}
                                          color={BindedValue}
                                          onChange={color => {
                                              BindedOnChange(color[color_type]);
                                          }}
                                      />
                                      <div ref={arrowProps.ref} style={arrowProps.style} />
                                  </div>
                              </div>
                            : null;
                    }}
                </Popper>
            </Manager>
            {!!text &&
                <span
                    className={classNames('flex-1 flex-grow ml-2 text-gray-500 text-sm font-bold')}
                >
                    {text}
                </span>}
        </div>
    );
};

ColorPicker.propTypes = {};

export default ColorPicker;
